const dates = [];

const lastDate = new Date(`07-01-${new Date().getFullYear()}`);
let day = "0";

for (
    let d = new Date(`04-01-${new Date().getFullYear()}`);
    d <= new Date(lastDate.setMonth(10));
    d.setDate(d.getDate() + 1)
) {
    if (new Date(d).getDay() === 0) {
        if (new Date(d).getDate() < 10) {
            day = `0${new Date(d).getDate()}`;
        } else {
            day = `${new Date(d).getDate()}`;
        }

        if (new Date(d).getMonth() + 1 >= 10) {
            dates.push(`${day}-${new Date(d).getMonth() + 1}-${new Date(d).getFullYear()}`);
        } else {
            dates.push(`${day}-0${new Date(d).getMonth() + 1}-${new Date(d).getFullYear()}`);
        }
    }
}

export default [
    {
        value: "",
        placeholder: "nom",
        question: "Quel est votre nom?",
        name: "name",
        type: "text",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        placeholder: "camping",
        question: "Quel est le nom du camping?",
        name: "camping_name",
        type: "text",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        placeholder: "adresse",
        question: "Quelle est votre adresse?",
        name: "camping_address",
        type: "text",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        placeholder: "E-mail",
        question: "Quel est votre e-mail?",
        name: "email",
        type: "email",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        placeholder: "Tel",
        question: "Quel est votre numéro de téléphone?",
        name: "tel",
        type: "tel",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Quel est votre code postal?",
        explanation:
            "Veuillez saisir votre code postal dans le format correct. Cela signifie que vous devez saisir cinq chiffres, par exemple : 12345.",
        pattern: "^(?:0[1-9]|[1-8]\\d|9[0-8])\\d{3}$",
        name: "zipcode",
        type: "text",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Durant quelle période avez-vous besoin d'animation?",
        explanation: "Vous pouvez sélectionner la date de fin après avoir sélectionné la date de début.",
        name: "required_date_from",
        type: "selectNextDate",
        options: dates,
        defaultDate: dates[0],
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Durant quelle période avez-vous besoin d'animation?",
        name: "required_date_until",
        type: "selectDate",
        options: [],
        defaultDate: "",
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        question: "Savez-vous déjà quel type de package vous recherchez ?",
        name: "known_package",
        type: "ratio",
        options: ["Oui", "Non"],
        step: 1,
        valid: false,
        required: true,
    },
    {
        value: "",
        question:
            "Comme il est noté dans notre brochure, nous offrons plusieurs packages optionnels. Le(s)quel(s) vous intéresse(nt) ?",
        name: "selected_package",
        type: "multiselect",
        options: [
            "Animation S",
            "Animation M",
            "Animation L",
            "Animation XL",
            "Animation XXL",
            "Lenny Club",
            "Nature",
            "Ados",
            "300% FUN",
            "Kids-Campings.com",
        ],
        step: 1,
        valid: true,
        required: false,
    },
    {
        value: "",
        question: "Avez-vous des remarques ?",
        name: "comments",
        type: "textarea",
        step: 1,
        valid: true,
        required: false,
    },
];
